import React from "react";

function Icon3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g fill="#fff" clipPath="url(#clip0_302_40)" opacity="1">
        <path
          fillRule="evenodd"
          d="M17 13.984V6.016H7.016V9H5V4.984C5 4.47 5.469 4 5.984 4h12c.563 0 1.032.469 1.032.984V8.5L23 4.516v10.968L19.016 11.5v3.516c0 .515-.47.984-1.032.984H13v-2.016h4z"
          clipRule="evenodd"
        ></path>
        <path d="M10.91 15.044H9.32a3.42 3.42 0 00-3.315-2.52c-.961.034-1.856.398-2.486 1.028-.033.033 0 .066-.033.1H5.01v1.458L1 15.143l.033-4.01h1.459l.033 1.359A5.083 5.083 0 016.005 11c2.42.033 4.408 1.757 4.906 4.044zm.1 1.89l-.033 4.01H9.518l-.033-1.36c-.895.896-2.121 1.46-3.48 1.426-2.42.033-4.408-1.69-4.906-3.978H2.69a3.42 3.42 0 003.315 2.52c.994 0 1.89-.431 2.52-1.127H6.998v-1.459l4.011-.033z"></path>
      </g>
      <defs>
        <clipPath id="clip0_302_40">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon3;